import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    viewChildren,
    ViewEncapsulation,
} from '@angular/core';
import { AvatarWithMessageComponent } from '@shared/avatar-with-message/avatar-with-message.component';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { FeatureSliderComponent } from '@shared/feature-slider/feature-slider.component';
import { FeaturesItemComponent } from '@shared/features-item/features-item.component';
import { TitleAndSubtitleComponent } from '@shared/title-and-subtitle/title-and-subtitle';
import { AvatarWithMessageItem } from '@shared/avatar-with-message/avatar-with-message.types';
import { AvatarSubtitle, AvatarTitle, RotatePosition } from '@shared/avatar-with-message/avatar-with-message.constants';
import { ScrollComponent } from '@shared/scroll/scroll.component';
import { featuresContent } from '@shared/features-content/features-content';
import { FeaturesItem } from '@content/features/features-type';

@Component({
    selector: 'companyid-features',
    imports: [
        AvatarWithMessageComponent,
        ContentWrapperComponent,
        FeatureSliderComponent,
        FeaturesItemComponent,
        TitleAndSubtitleComponent,
    ],
    templateUrl: './features.component.html',
    styleUrl: './features.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturesComponent extends ScrollComponent implements AfterViewInit {
    public readonly featuresContent: FeaturesItem[] = featuresContent;
    public featureItems = viewChildren<string, ElementRef<HTMLDivElement>>('featureItems', {
        read: ElementRef,
    });

    public readonly avatarContent: AvatarWithMessageItem[] = [
        {
            classNames: 'tab:hidden mob:hidden absolute top-[193px] left-[1124px] w-max hide-avatar',
            avatarImg: 'woman',
            title: AvatarTitle.HI_I_AM_AN,
            subtitle: AvatarSubtitle.ACCOUNTANT,
            position: RotatePosition.EIGHT_DEG,
        },
        {
            classNames: 'tab:hidden mob:hidden absolute top-[320px] left-[600px]',
            avatarImg: 'man',
            title: AvatarTitle.YO_I_AM,
            subtitle: AvatarSubtitle.SMM,
            position: RotatePosition.ZERO_DEG,
        },
        {
            classNames: 'tab:hidden mob:hidden absolute top-[-40px] left-[440px]',
            avatarImg: 'girl',
            title: AvatarTitle.HI_I_AM_A,
            subtitle: AvatarSubtitle.CEO,
            position: RotatePosition.TWO_DEG,
        },
    ];

    public ngAfterViewInit(): void {
        this.onScroll(this.featureItems());
    }
}
